<template>
  <div class="m-shipping-methods">
    <h2 class="m-shipping-methods__headline h4">
      {{ $t("shippingMethodsHeadline", "Levering") }}
    </h2>
    <div class="m-shipping-methods__wrapper d-flex">
      <base-radio
        v-for="(method, index) in shippingMethods"
        :id="method.shippingDisplayName"
        :key="index"
        v-model="selectedShippingMethod"
        v-validate="'required'"
        :required="true"
        :name="method.shippingDisplayName"
        :value="method.shippingMethodId.toString()"
        class="-shipping-method"
        @input="changeShippingMethod"
      >
        <template v-slot:label>
          <div class="a-radio__label">
            <div class="">
              {{ method.shippingDisplayName }}
            </div>
          </div>
        </template>
      </base-radio>
    </div>
    <shipping-methods-company-delivery
      v-if="selectedShippingMethod && isCompanyDeliverySelected"
      v-model="value.shippingAddress"
      :account-shipping-address="accountShippingAddress"
      @input="updateShippingAddressFields"
      @reset-shipping-address="emitResetShippingAddress"
      @update-shipping-address="emitUpdateShippingAddress"
      @update-is-another-address-selected="emitUpdateIsAnotherAddressSelected"
    />
    <shipping-methods-warehouse-pickup
      v-if="selectedShippingMethod && isWarehousePickupSelected"
      v-model="value.shippingAddress"
      :address="warehouseAddress"
      :postal-code="warehousePostalCode"
      :city="warehouseCity"
      :opening-hours="warehouseOpeningHours"
      :coordinates="warehouseCoordinates"
      @input="updateShippingAddressFields"
      @update-shipping-address="emitUpdateShippingAddress"
    />
  </div>
</template>

<script>
import BaseRadio from '@/components/atoms/BaseRadio.vue';
import ShippingMethodsCompanyDelivery from '@/components/molecules/ShopCommerce/ShippingMethodsCompanyDelivery.vue';
import ShippingMethodsWarehousePickup from '~/components/molecules/ShopCommerce/ShippingMethodsWarehousePickup.vue';

export default {
  name: 'ShippingMethods',
  inject: ['$validator'],
  components: {
    BaseRadio,
    ShippingMethodsCompanyDelivery,
    ShippingMethodsWarehousePickup,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    accountShippingAddress: {
      type: Object,
      default: () => {}
    },
    companyDeliveryName: {
      type: String,
      default: ''
    },
    warehousePickupName: {
      type: String,
      default: '',
    },
    warehouseAddress: {
      type: String,
      default: ''
    },
    warehousePostalCode: {
      type: String,
      default: ''
    },
    warehouseCity: {
      type: String,
      default: ''
    },
    warehouseOpeningHours: {
      type: Array,
      default: () => []
    },
    warehouseCoordinates: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      selectedShippingMethod: null,
    }
  },
  computed: {
    currentCulture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    shippingMethods () {
      return this.$store.getters['checkout/checkout/getShippingMethods'];
    },
    companyDeliveryId () {
      return this.shippingMethods.find((shippingMethod) => shippingMethod.shippingMethodName === this.companyDeliveryName)?.shippingMethodId.toString();
    },
    warehousePickupId () {
      return this.shippingMethods.find((shippingMethod) => shippingMethod.shippingMethodName === this.warehousePickupName)?.shippingMethodId.toString();
    },
    isCompanyDeliverySelected () {
      return this.companyDeliveryId === this.value.shippingMethod;
    },
    isWarehousePickupSelected () {
      return this.warehousePickupId === this.value.shippingMethod;
    },
  },
  async mounted () {
    await this.$store.dispatch('checkout/checkout/fetchShippingMethods', { culture: this.currentCulture });
  },
  methods: {
    updateField (fieldName, fieldValue) {
      this.$emit('input', {
        ...this.value,
        [fieldName]: fieldValue,
      });
    },
    updateShippingAddressFields (shippingAddress) {
      this.updateField('shippingAddress', shippingAddress)
    },
    changeShippingMethod (fieldValue) {
      this.updateField('shippingMethod', fieldValue);
      this.$store.dispatch('checkout/checkout/setShippingMethod', {
        culture: this.currentCulture,
        shippingMethodId: fieldValue
      });
      this.emitResetShippingAddress();
    },

    emitResetShippingAddress () {
      this.$emit('reset-shipping-address');
    },

    emitUpdateShippingAddress (param) {
      this.$emit('update-shipping-address', param);
    },
    emitUpdateIsAnotherAddressSelected (param) {
      this.$emit('update-is-another-address-selected', param);
    }
  }
}
</script>
